import React from 'react'

function TermsnConditions() {
  return (
     <div className="content-area">TermsnConditions</div>
  )
}

export default TermsnConditions